import { useContext } from 'react';

import { Button } from 'components/rebrand/Button';
import { LocaleContext } from 'components/rebrand/Layout';

import { IArticleSanityData } from 'typescriptDefs/pages/learn/article';

import { useIsMobileSize } from 'helpers';

import { SocialShare } from '../../../SocialShare';

const findByInnerText = (text: string) =>
  document.evaluate(
    `//*[text()="${text.replaceAll('"', "'")}"]`,
    document,
    null,
    XPathResult.FIRST_ORDERED_NODE_TYPE,
    null,
  ).singleNodeValue as HTMLElement | null;

type Heading = { text: string };
type Props = {
  article: IArticleSanityData;
  headings: Heading[];
  pathname: string;
};

export const ContentsSidebar = ({ article, headings, pathname }: Props) => {
  const locale = useContext(LocaleContext);
  const isMobile = useIsMobileSize();

  return (
    <div>
      {!isMobile && headings.length > 0 && (
        <div className="mt-48 text-md">
          <h2 className="text-4xl font-bold">{{ en: `Content`, fr: `Contenu` }[locale]}</h2>
          <div className="mb-48 mt-16 flex flex-col gap-12">
            {headings.map((heading, i) => (
              <Button
                key={i}
                variant="text"
                className="w-fit px-0 text-left font-medium transition-colors duration-300 hover:text-primary-300 focus:text-primary-300 active:text-primary-300"
                onClick={() => {
                  const headingEl = findByInnerText(heading.text);
                  if (headingEl) {
                    const offset = 75;
                    const headingElPosition = headingEl.getBoundingClientRect().top;
                    const offsetPosition = headingElPosition + window.scrollY - offset;
                    window.scrollTo({ top: offsetPosition });
                  }
                }}
                dangerouslySetInnerHTML={{ __html: heading.text }}
              />
            ))}
          </div>
        </div>
      )}
      <SocialShare pathname={pathname} title={article.title} />
    </div>
  );
};
